import { render } from "./CardsDuplicateDialog.vue?vue&type=template&id=b89720b6&ts=true"
import script from "./CardsDuplicateDialog.vue?vue&type=script&lang=ts"
export * from "./CardsDuplicateDialog.vue?vue&type=script&lang=ts"

import "./CardsDuplicateDialog.vue?vue&type=style&index=0&id=b89720b6&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__